export const PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE =
  'planner-discovery-inbox-card';
export const PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED =
  'planner-discovery-inbox-card-dismissed';
export const READ_INBOX_NOTIFICATIONS_TIMEOUT = 5000;
